import { ROUTES } from '@/constants/routes'

export const PRODUCT_SOURCES = {
  CL: 'CL',
  LP: 'LP'
}

export const DEFAULT_PRODUCT_SOURCE = PRODUCT_SOURCES.CL

export const DEFAULT_LOGIN_BRANDING = {
  loginTitle: 'Welcome PayU Finance',
  loginSubtitle: 'Please enter your phone number to proceed'
}

export const CL_ENDPOINTS = {
  sendOtp: '/users/otp',
  verifyLogin: '/users/login',
  authenticate: '/users/authenticate',
  logout: '/users/logout',
  generateEmailOtp: '/users/generate-email-otp',
  resendEmailOtp: '/users/generate-email-otp',
  verifyEmailOtp: '/users/verify-email-otp',
  sendUserEmailOtp: '/users/email-otp',
  raiseComplaintTicket: '/users/raise/ticket'
}

export const LP_ENDPOINTS = {
  sendOtp: '/send-otp-to-mobile',
  verifyLogin: '/verify-mobile-otp',
  authenticate: '/users/authenticate',
  generateEmailOtp: '/users/send-email-otp',
  resendEmailOtp: '/users/send-email-otp',
  verifyEmailOtp: '/users/verify-email-otp',
  sendUserEmailOtp: '/users/send-email-otp'
}

export const ENDPOINT_PATHS = CL_ENDPOINTS

export const PRODUCT_ENDPOINTS = {
  [PRODUCT_SOURCES.CL]: CL_ENDPOINTS,
  [PRODUCT_SOURCES.LP]: LP_ENDPOINTS
}

const PRODUCT_CONFIG_DEFAULTS = {
  [PRODUCT_SOURCES.CL]: {
    defaultReturnPath: '/cashloan/profile',
    branding: DEFAULT_LOGIN_BRANDING,
    features: {
      complaint: true,
      emailVerification: true,
      branding: true
    }
  },
  [PRODUCT_SOURCES.LP]: {
    defaultReturnPath: ROUTES.EMAIL_VERIFICATION,
    branding: DEFAULT_LOGIN_BRANDING,
    features: {
      complaint: false,
      emailVerification: true,
      branding: true
    }
  }
}

const API_BASE_URLS = {
  [PRODUCT_SOURCES.CL]: import.meta.env.VITE_API_BASE_URL_CL || '',
  [PRODUCT_SOURCES.LP]: import.meta.env.VITE_API_BASE_URL_LP || ''
}

const PLATFORM_KEYS = {
  [PRODUCT_SOURCES.CL]: import.meta.env.VITE_PLATFORM_KEY_CL || '',
  [PRODUCT_SOURCES.LP]: import.meta.env.VITE_PLATFORM_KEY_LP || ''
}

/** LP home / marketing site — used after email verification when no returnUrl is set. */
export const LP_WEBSITE_URL = import.meta.env.VITE_LP_WEBSITE_URL || ''

export const isValidSource = source => Object.values(PRODUCT_SOURCES).includes(source)

export const buildProductConfig = source => {
  if (!isValidSource(source)) return null

  const defaults = PRODUCT_CONFIG_DEFAULTS[source]

  return {
    source,
    apiBaseUrl: API_BASE_URLS[source],
    platformKey: PLATFORM_KEYS[source],
    endpoints: { ...PRODUCT_ENDPOINTS[source] },
    defaultReturnPath: defaults.defaultReturnPath,
    branding: { ...defaults.branding },
    features: { ...defaults.features }
  }
}

export const getApiUrl = (config, endpointKey) => {
  const endpointPath = config?.endpoints?.[endpointKey]

  if (!config?.apiBaseUrl || !endpointPath) return ''

  return `${config.apiBaseUrl}${endpointPath}`
}
